
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/real-estate-guide-for-buyers",
      function () {
        return require("private-next-pages/blog/real-estate-guide-for-buyers/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/real-estate-guide-for-buyers"])
      });
    }
  